
















































































































































































































































































































import { Component } from "vue-property-decorator";
import moment from "moment";
import { required, email, sameAs } from "vuelidate/lib/validators";
import { Validate } from "vuelidate-property-decorators";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
@Component({})
export default class RegisterComponent extends mixins(NotificationEvent) {
  jsonCountry = require("../../../../../assets/education/registerEducation.json");
  jsonCountryParse = null;
  @Validate({ required, $autoDirty: false })
  name = "";
  @Validate({ required })
  lastName = "";
  @Validate({ required, email })
  email = "";
  //@Validate({ required })
  //birthday = null;
  @Validate({ required })
  password = "";
  @Validate({
    required,
    sameAs: sameAs("password"),
  })
  confirmPassword = "";
  //today = null;
  @Validate({ required })
  language = "";
  @Validate({ required })
  law = "";
  rol = "TEACHER";
  hasVisiblePassword = false;
  hasVisibleConfirmPassword = false;
  educationCountry = [];
  educationLaws = [];
  done = false;
  constructor() {
    super();
    if (!window.location.host.includes("hawkings.education")) {
      this.$router.push("/quickstart");
      return;
    }
    //this.today = moment(new Date()).utc().format("yyyy-MM-DD");
    this.jsonCountryParse = JSON.parse(JSON.stringify(this.jsonCountry));
    this.educationCountry = this.jsonCountryParse.country;
    window.addEventListener("resize", () => {
      let width = document.getElementById("title").offsetWidth;
      if (width <= 720) document.getElementById("back").style.color = "black";
      else document.getElementById("back").style.color = "white";

      let leftContainer = document.getElementById("leftContainer").offsetHeight;
      let title = document.getElementById("title").offsetHeight;
      let logo = document.getElementById("logo").offsetHeight;
      let height = leftContainer + logo;
      document.getElementById("rightContainer").style.height =
        height.toString() + "px";
    });
  }
  selectLaws(value: string) {
    this.law = "";
    this.educationLaws = [];
    this.jsonCountryParse.country.forEach((element) => {
      if (element.name.value == value) this.educationLaws = element.laws;
    });
  }
  getProgress(value: string): number {
    let progress = 0;

    // more than 5 digits
    if (value.length >= 6) {
      progress += 20;
      // at least one number
      if (/\d/.test(value)) {
        progress += 20;
      }
      if (/(.*[A-Z].*)/.test(value)) {
        progress += 20;
      }
      // at menons a lowercase
      if (/(.*[a-z].*)/.test(value)) {
        progress += 20;
      }
      // at least one special character
      if (/[^A-Za-z0-9]/.test(value)) {
        progress += 20;
      }
    } else if (value.length > 0) {
      progress = 20;
    }

    return progress;
  }
  register() {
    if (this.$v.$invalid) {
      this.$v.name.$touch();
      this.$v.lastName.$touch();
      this.$v.email.$touch();
      this.$v.language.$touch();
      this.$v.law.$touch();
      this.$v.password.$touch();
      this.$v.confirmPassword.$touch();
      //this.$v.birthday.$touch();
      return;
    }
    /*this.birthday = moment(this.birthday).isValid()
      ? moment.utc(this.birthday).format("yyyy-MM-DD")
      : null;*/
    this.$store.dispatch("HawkingsStore/registerAction", {
      data: {
        email: this.email,
        name: this.name,
        lastName: this.lastName,
        password: this.password,
        country: this.language,
        educationLaw: this.law,
        //birthday: this.birthday,
        type: this.rol,
        domain: "HAWKINGS",
        language: i18n.locale,
      },
      callback: (response) => {
        if (response.data.status === "KO") {
          this.onError(
            i18n.t("notifications.titles.error"),
            i18n.t("register.registeredUserError"),
            "none"
          );
        } else {
          this.done = true;
          /*this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("register.activeUser"),
            "none"
          );*/
        }
      },
      callbackError: (error) => {
        this.onError(
          i18n.t("notifications.titles.error"),
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          }),
          "none"
        );
      },
    });
  }
}
